import _ from 'lodash';

type EventData = any;
type Event = string;
type EventListener<E extends Event> = (event: { type: E; data: EventData }) => void;
type Listeners<E extends Event> = Record<E, EventListener<E>[]>;

export class EventEmitter<E extends Event> {
	listeners: Listeners<E> = {} as Listeners<E>;

	addListener = (event: E, listener: EventListener<E>) => {
		if (!this.listeners[event]) {
			this.listeners[event] = [];
		}

		this.listeners[event].push(listener);
	};

	removeListener = (event: E, listener: EventListener<E>) => {
		if (!this.listeners[event]) {
			return;
		}

		const index = this.listeners[event].indexOf(listener);

		if (index >= 0) {
			this.listeners[event].splice(index, 1);
		}
	};

	emit = (event: E, data: EventData = null) => {
		_.forEach(this.listeners[event], listener => {
			listener({ type: event, data });
		});
	};

	destroy = () => {
		this.listeners = {} as Listeners<E>;
	};
}
